import {Sorter} from "../models/Quote";

import {SGBMarket} from "../models/SGBMarket";

export class Filters{

    static ProfitableSeller= (s:SGBMarket)=>s.minSeller!==0 && s.minSeller<s.profitablePrice
    static NO_BID= (s:SGBMarket)=>s.myBid===null
    static TRADED_TODAY= (s:SGBMarket)=>s.sgb.tick.volume_traded>0
    static PROFITABLE_LOW= (s:SGBMarket)=>s.sgb.tick.average_traded_price!==0 && s.sgb.tick.ohlc.low <= (s.profitablePrice+15)
    static LessThan6= (s:SGBMarket)=>s.months<=6
    static LessThan12= (s:SGBMarket)=>s.months<=12
    static LessThan18= (s:SGBMarket)=>s.months<=18
    static LessThan24= (s:SGBMarket)=>s.months<=24
    static MyBids= (s:SGBMarket)=>s.myBid!==null
    static Holding= (s:SGBMarket)=>s.holding>0

    static CanPlaceBetterBid= (s:SGBMarket)=>s.maxBuyer <= s.profitablePrice

    static defaultFilter=(sgb:SGBMarket)=>true
    static noBuyer=(p1: SGBMarket)=> p1.maxBuyer===0;
    static profitAverageTP=(p1: SGBMarket) => p1.sgb.tick.average_traded_price!==0 && p1.sgb.tick.average_traded_price <p1.profitablePrice
    static AUTO=(sgb: SGBMarket) => Filters.CanPlaceBetterBid(sgb) && (sgb.maxBuyer > (sgb.myBid?.price??0))
}

export class Sorters{

    static createNew(_sorter: (sgb1: SGBMarket, sgb2: SGBMarket) => number, flag: boolean) {
        return function (p1: SGBMarket, p2: SGBMarket) {
            let val = _sorter(p1, p2);
            return flag? val : -val;
        };
    }

    static monthsToRedeem:Sorter = (a:SGBMarket, b:SGBMarket)=> a.months - b.months;
    static PROFITABLE:Sorter = (a:SGBMarket, b:SGBMarket)=> a.profitablePrice - b.profitablePrice;
    static buyer = (a:SGBMarket, b:SGBMarket)=>(Math.max(a.maxBuyer!, a.sgb.circuits.lowerCircuit) - Math.max(b.maxBuyer!, b.sgb.circuits.lowerCircuit))
    static profitableDiff = (a:SGBMarket, b:SGBMarket)=>(Math.max(a.sgb.circuits.lowerCircuit, a.maxBuyer!) - a.profitablePrice!) - (Math.max(b.sgb.circuits.lowerCircuit, b.maxBuyer!) - b.profitablePrice!)
    static profitableSellerDiff = (a:SGBMarket, b:SGBMarket)=>(a.minSeller! - a.profitablePrice!) - (b.minSeller! - b.profitablePrice!)
    static last_price = (a:SGBMarket, b:SGBMarket)=>a.sgb.tick.last_price! - b.sgb.tick.last_price!
    static ltp = (a:SGBMarket, b:SGBMarket)=>a.sgb.tick.last_price! - b.sgb.tick.last_price!
    static myBid = (a:SGBMarket, b:SGBMarket)=>a.myBid?.price - b.myBid?.price
    static seller = (a:SGBMarket, b:SGBMarket)=>a.minSeller! - b.minSeller!
    static buyYTM = (a:SGBMarket, b:SGBMarket)=>a.buyYTM! - b.buyYTM!
    static bidYTM = (a:SGBMarket, b:SGBMarket)=>a.bidYTM! - b.bidYTM!
    static days = (a:SGBMarket, b:SGBMarket)=>a.daysForCoupon! - b.daysForCoupon!
    static couponVal = (a:SGBMarket, b:SGBMarket)=>a.coupon! - b.coupon!
    static volume = (a:SGBMarket, b:SGBMarket)=>a.sgb.tick.volume_traded! - b.sgb.tick.volume_traded!
    static atp = (a:SGBMarket, b:SGBMarket)=>a.sgb.tick.average_traded_price! - b.sgb.tick.average_traded_price!
    static ltt = (a:SGBMarket, b:SGBMarket)=>a.sgb.tick.last_trade_time! - b.sgb.tick.last_trade_time!
    static low = (a:SGBMarket, b:SGBMarket)=>a.sgb.tick.ohlc.low! - b.sgb.tick.ohlc.low!
}
